export const maxTableWidth = "max-w-[1800px]";
